import React, { Component } from 'react';

export default class view extends Component {
	render() {
		return (
			<div  style={{textAlign:'left', padding: "0 25px", overflowWrap: 'break-word' }}>
				<h3 style={{textAlign:'center'}}>Medicaid Enteral Coverage Criteria</h3>
				<hr/>
				<p>Enteral nutritional therapy is only covered by Medicaid as an integral component of a documented medical treatment plan ordered in writing by an authorized prescriber. There must be a documented diagnosis showing that caloric and dietary nutrients from food cannot be absorbed or metabolized. This must be substantiated in the patient's medical record by documented physical findings or laboratory data. </p>
				
				<p>Enteral nutritional therapy is not covered as a supplement of daily protein-caloric intake when there is not documented medical necessity or as a convenient food substitute.</p>
				<p>For more information about Enteral Coverage go to,</p>
				<p><a href="https://www.emedny.org/ProviderManuals/DME/PDFS/DME_Procedure_Codes.pdf">https://www.emedny.org/ProviderManuals/DME/PDFS/DME_Procedure_Codes.pdf</a></p>
				<p><a href="https://regs.health.ny.gov/volume-c-title-18/633338692/section-5055-durable-medical-equipment-medicalsurgical-supplies-orthotic">https://regs.health.ny.gov/volume-c-title-18/633338692/section-5055-durable-medical-equipment-medicalsurgical-supplies-orthotic</a></p>
			</div>
		);
	}
}